// Building and downloading the Excel form template, in one place.
//
// Two screens offer it — the new-form screen's Excel on-ramp and the Form
// Definitions Import menu — and the filename, the MIME type and the
// "fetch the whole Field Library first" step have to agree between them. They
// are here rather than duplicated because a template downloaded from one entry
// point and uploaded at the other must be the same file.
//
// Errors are thrown, not swallowed: each caller surfaces failures in its own
// way (the editor folds them into its Excel error list, the menu shows a line
// under the item), so this does not own that decision.

import { fieldLibraryApi } from '@/api/fieldLibraryApi'
import { buildFormTemplate, FORM_TEMPLATE_MIME } from '@/lib/formExcel'
import { downloadBinaryFile } from '@/lib/csv'

export const FORM_TEMPLATE_FILENAME = 'form-template.xlsx'

/**
 * Download the form template pre-filled with this tenant's Field Library.
 *
 * `listAllFields` pages past the 100-row API cap — the template's dropdowns
 * have to offer every field, not the first page of them.
 */
export async function downloadFormTemplate(): Promise<void> {
  const fields = await fieldLibraryApi.listAllFields()
  const buf = await buildFormTemplate(fields)
  downloadBinaryFile(FORM_TEMPLATE_FILENAME, buf, FORM_TEMPLATE_MIME)
}
